import { render } from "./todayActor.vue?vue&type=template&id=4576f932&scoped=true"
import script from "./todayActor.vue?vue&type=script&lang=js"
export * from "./todayActor.vue?vue&type=script&lang=js"

import "./todayActor.vue?vue&type=style&index=0&id=4576f932&lang=less&scoped=true"
import "./todayActor.vue?vue&type=style&index=1&id=4576f932&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4576f932"]])

export default __exports__